import type { PropertyData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { useFormContext } from "react-hook-form";
import { DropdownField } from "../../form/DropdownField";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { useSetSearchInputAtom } from "../search/searchInputAtom";
import { emptyLocationDropdownItem } from "./constants";
import { useSetStatesCitiesAtom, useStatesCitiesAtomValue } from "./statesCitiesAtom";

export const StateDropdown: FunctionComponent = () => {
    const { states } = useStatesCitiesAtomValue();
    const setStatesCitiesAtom = useSetStatesCitiesAtom();
    const setSearchInput = useSetSearchInputAtom();
    const {
        cmsData: {
            location: { stateProvince, pleaseEnterState, youMustSelectACountryRegion },
        },
    } = useStaticDataAtomValue();
    const { setValue: setFormValue } = useFormContext<PropertyData>();

    const handleChange = () => {
        setSearchInput("");
        setFormValue("city", emptyLocationDropdownItem);
        setFormValue("streetAddress", "");
        // clear state and city dropdown options
        setStatesCitiesAtom((p) => ({
            ...p,
            cities: [],
        }));
    };

    return (
        <DropdownField
            label={stateProvince}
            field="state"
            items={states}
            defaultValue={emptyLocationDropdownItem}
            onChange={handleChange}
            rules={{
                validate: {
                    notEmpty: (v) => (v !== null && v.id !== 0) || pleaseEnterState,
                },
            }}
            blankState={youMustSelectACountryRegion}
            dataElementName="state-province"
        />
    );
};
